var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15013_437702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09906 13.9412C5.07906 13.9412 5.0524 13.9545 5.0324 13.9545C3.73906 13.3145 2.68573 12.2545 2.03906 10.9612C2.03906 10.9412 2.0524 10.9145 2.0524 10.8945C2.86573 11.1345 3.70573 11.3145 4.53906 11.4545C4.68573 12.2945 4.85906 13.1279 5.09906 13.9412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9594 10.9679C13.2994 12.2945 12.1994 13.3679 10.8594 14.0145C11.1127 13.1679 11.326 12.3145 11.466 11.4545C12.306 11.3145 13.1327 11.1345 13.946 10.8945C13.9394 10.9212 13.9594 10.9479 13.9594 10.9679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0127 5.14161C13.1727 4.88828 12.326 4.68161 11.466 4.53495C11.326 3.67495 11.1194 2.82161 10.8594 1.98828C12.2394 2.64828 13.3527 3.76161 14.0127 5.14161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10161 2.05906C4.86161 2.8724 4.68828 3.69906 4.54828 4.53906C3.68828 4.6724 2.83495 4.88573 1.98828 5.13906C2.63495 3.79906 3.70828 2.69906 5.03495 2.03906C5.05495 2.03906 5.08161 2.05906 5.10161 2.05906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3252 4.39203C8.77854 4.2187 7.21854 4.2187 5.67188 4.39203C5.83854 3.4787 6.05187 2.56536 6.35187 1.68536C6.36521 1.63203 6.35854 1.59203 6.36521 1.5387C6.89188 1.41203 7.43187 1.33203 7.99854 1.33203C8.55854 1.33203 9.10521 1.41203 9.62521 1.5387C9.63187 1.59203 9.63188 1.63203 9.64521 1.68536C9.94521 2.57203 10.1585 3.4787 10.3252 4.39203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39203 10.3252C3.47203 10.1585 2.56536 9.94521 1.68536 9.64521C1.63203 9.63188 1.59203 9.63854 1.5387 9.63187C1.41203 9.10521 1.33203 8.56521 1.33203 7.99854C1.33203 7.43854 1.41203 6.89188 1.5387 6.37188C1.59203 6.36521 1.63203 6.36521 1.68536 6.35187C2.57203 6.05854 3.47203 5.83854 4.39203 5.67188C4.22536 7.21854 4.22536 8.77854 4.39203 10.3252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6655 7.99854C14.6655 8.56521 14.5855 9.10521 14.4588 9.63187C14.4055 9.63854 14.3655 9.63188 14.3121 9.64521C13.4255 9.93854 12.5188 10.1585 11.6055 10.3252C11.7788 8.77854 11.7788 7.21854 11.6055 5.67188C12.5188 5.83854 13.4321 6.05187 14.3121 6.35187C14.3655 6.36521 14.4055 6.37188 14.4588 6.37188C14.5855 6.89854 14.6655 7.43854 14.6655 7.99854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3252 11.6055C10.1585 12.5255 9.94521 13.4321 9.64521 14.3121C9.63188 14.3655 9.63187 14.4055 9.62521 14.4588C9.10521 14.5855 8.55854 14.6655 7.99854 14.6655C7.43187 14.6655 6.89188 14.5855 6.36521 14.4588C6.35854 14.4055 6.36521 14.3655 6.35187 14.3121C6.05854 13.4255 5.83854 12.5255 5.67188 11.6055C6.44521 11.6921 7.21854 11.7521 7.99854 11.7521C8.77854 11.7521 9.55854 11.6921 10.3252 11.6055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5076 10.5076C8.84019 10.718 7.15721 10.718 5.48981 10.5076C5.27944 8.84019 5.27944 7.15721 5.48981 5.48981C7.15721 5.27944 8.84019 5.27944 10.5076 5.48981C10.718 7.15721 10.718 8.84019 10.5076 10.5076Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15013_437702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobal);
export default __webpack_public_path__ + "static/media/ic-global.2ef946d0fb7a0151959d1eaf28c38c10.svg";
export { ForwardRef as ReactComponent };